<div class="loading-screen-wrapper" *ngIf="loadingFlag">
    <img src="assets/images/preloader.gif" />
</div>
<div class="loading-screen-download-wrapper" *ngIf="loadingFilter">
    <img src="assets/images/35.gif" />
</div>